/**
 * Created by alvinoktavianus on 5/9/17.
 */

import {
  SETTING_BILLING_BILLINGS,
  SETTING_BILLING_CANCEL_FEATURE_SUBSCRIPTION,
  SETTING_BILLING_FEATURE_SUBSCRIPTION_PRICE,
  SETTING_BILLING_HIDE_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
  SETTING_BILLING_HIDE_PAYMENT_GATEWAY_ERROR_MODAL,
  SETTING_BILLING_IS_CLICKED_BUTTON_PAY,
  SETTING_BILLING_ON_CHANGE_SUBSCRIPTION_RULES,
  SETTING_BILLING_ON_CLICK_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
  SETTING_BILLING_ON_CLICK_TURN_BUTTON,
  SETTING_BILLING_PAGE_REQUEST,
  SETTING_BILLING_PAY_BUTTON_MESSAGE,
  SETTING_BILLING_PAY_MOKA_SUBSCRIPTION,
  SETTING_BILLING_RULES_OUTLETS_SUBSCRIPTION_RULES,
  SETTING_BILLING_SET_BILLINGS,
  SETTING_BILLING_SET_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
  SETTING_BILLING_SET_COUNT_FEATURE_SUBSCRIPTION,
  SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_PLAN_NAME,
  SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_RULES,
  SETTING_BILLING_SET_FEATURE_SUBSCRIPTION_PRICE,
  SETTING_BILLING_SET_IS_DELETED_OUTLET,
  SETTING_BILLING_SET_MIN_MAX_EXPIRATION_DATE,
  SETTING_BILLING_SET_OUTLETS,
  SETTING_BILLING_SET_PENDING_PAYMENT_MESSAGE,
  SETTING_BILLING_SET_RULES,
  SETTING_BILLING_SET_SUBSCRIPTION_STATUS,
  SETTING_BILLING_SET_TOTAL_BILLING_PRICE,
  SETTING_BILLING_SET_UNUSED_OUTLETS_MESSAGE,
  SETTING_BILLING_SHOW_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
  SETTING_BILLING_SHOW_PAYMENT_GATEWAY_ERROR_MODAL,
  SETTING_BILLING_VERIFY_BILLING_COUPON,
  SETTING_BILLING_SET_STATUS_VALIDATION_COUPON,
  SETTING_BILLING_SET_COUPON_DISCOUNT,
  SETTING_BILLING_SET_COUPON_DISCOUNT_REQUEST,
  SETTING_BILLING_SET_COUPON_ERROR_MESSAGE,
  SETTING_BILLING_IS_VALIDATING_COUPON
} from './constant'

export function billingPageRequest (currentPlan, expired, isOwner, billingNotification) {
  return {
    type: SETTING_BILLING_PAGE_REQUEST,
    payload: {currentPlan, expired, isOwner, billingNotification}
  }
}

export function rulesOutletsSubscriptionStatus (currentPlan, expired, isTrial, outletSlot) {
  return {
    type: SETTING_BILLING_RULES_OUTLETS_SUBSCRIPTION_RULES,
    payload: {currentPlan, expired, isTrial, outletSlot}
  }
}

export function billings () {
  return {
    type: SETTING_BILLING_BILLINGS
  }
}

export function setBillings (data) {
  return {
    type: SETTING_BILLING_SET_BILLINGS,
    payload: {data}
  }
}

export function setOutlets (data) {
  return {
    type: SETTING_BILLING_SET_OUTLETS,
    payload: {data}
  }
}

export function setRules (data) {
  return {
    type: SETTING_BILLING_SET_RULES,
    payload: {data}
  }
}

export function setSubscriptionStatus (data) {
  return {
    type: SETTING_BILLING_SET_SUBSCRIPTION_STATUS,
    payload: {data}
  }
}

export function onChangeSubscriptionRules (subscriptionRules) {
  return {
    type: SETTING_BILLING_ON_CHANGE_SUBSCRIPTION_RULES,
    payload: {subscriptionRules}
  }
}

export function setCurrentSubscriptionRules (newSubscriptionRules) {
  return {
    type: SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_RULES,
    payload: {newSubscriptionRules}
  }
}

export function payMokaSubscription (totalPrice, subscriptionPlan, purchasedOutlets, activatedFeatures, couponDiscount, couponDiscountRequest) {
  return {
    type: SETTING_BILLING_PAY_MOKA_SUBSCRIPTION,
    payload: {totalPrice, subscriptionPlan, purchasedOutlets, activatedFeatures, couponDiscount, couponDiscountRequest}
  }
}

export function isClickedPayButton (payButtonClicked) {
  return {
    type: SETTING_BILLING_IS_CLICKED_BUTTON_PAY,
    payload: {payButtonClicked}
  }
}

export function payButtonMessage (payButtonMessage) {
  return {
    type: SETTING_BILLING_PAY_BUTTON_MESSAGE,
    payload: {payButtonMessage}
  }
}

export function showPaymentGatewayErrorModal () {
  return {
    type: SETTING_BILLING_SHOW_PAYMENT_GATEWAY_ERROR_MODAL
  }
}

export function hidePaymentGatewayErrorModal () {
  return {
    type: SETTING_BILLING_HIDE_PAYMENT_GATEWAY_ERROR_MODAL
  }
}

export function setTotalBillingPrice (totalBillingPrice) {
  return {
    type: SETTING_BILLING_SET_TOTAL_BILLING_PRICE,
    payload: {totalBillingPrice}
  }
}

export function setPendingPaymentMessage (pendingPaymentMessage) {
  return {
    type: SETTING_BILLING_SET_PENDING_PAYMENT_MESSAGE,
    payload: {pendingPaymentMessage}
  }
}

export function setUnusedOutletMessage (unusedOutletMessage) {
  return {
    type: SETTING_BILLING_SET_UNUSED_OUTLETS_MESSAGE,
    payload: {unusedOutletMessage}
  }
}

export function setCurrentSubscriptionPlanName (planName) {
  return {
    type: SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_PLAN_NAME,
    payload: {planName}
  }
}

export function setCountFeatureSubscription (countFeatureSubscription) {
  return {
    type: SETTING_BILLING_SET_COUNT_FEATURE_SUBSCRIPTION,
    payload: {countFeatureSubscription}
  }
}

export function onClickCancelSubscriptionModal (featureSubscriptionModalData) {
  return {
    type: SETTING_BILLING_ON_CLICK_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
    payload: {featureSubscriptionModalData}
  }
}

export function setCancelSubsciptionModalData (featureSubscriptionModalData) {
  return {
    type: SETTING_BILLING_SET_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
    payload: {featureSubscriptionModalData}
  }
}

export function showCancelSubscriptionModal () {
  return {
    type: SETTING_BILLING_SHOW_CANCEL_FEATURE_SUBSCRIPTION_MODAL
  }
}

export function hideCancelSubscriptionModal () {
  return {
    type: SETTING_BILLING_HIDE_CANCEL_FEATURE_SUBSCRIPTION_MODAL
  }
}

export function featureSubscriptionPrice () {
  return {
    type: SETTING_BILLING_FEATURE_SUBSCRIPTION_PRICE
  }
}

export function setFeatureSubscriptionPrice (featureSubscriptionPrice) {
  return {
    type: SETTING_BILLING_SET_FEATURE_SUBSCRIPTION_PRICE,
    payload: {featureSubscriptionPrice}
  }
}

export function cancelFeatureSubscription (featureName, featureSubscriptionStatus, outletMinMaxDate) {
  return {
    type: SETTING_BILLING_CANCEL_FEATURE_SUBSCRIPTION,
    payload: {featureName, featureSubscriptionStatus, outletMinMaxDate}
  }
}

export function setMinMaxDate (minMaxDate) {
  return {
    type: SETTING_BILLING_SET_MIN_MAX_EXPIRATION_DATE,
    payload: {minMaxDate}
  }
}

export function onClickTurnButton (id, prevIsDeleted) {
  return {
    type: SETTING_BILLING_ON_CLICK_TURN_BUTTON,
    payload: {id, prevIsDeleted}
  }
}

export function setIsDeletedOutlet (isDeleted) {
  return {
    type: SETTING_BILLING_SET_IS_DELETED_OUTLET,
    payload: {isDeleted}
  }
}

export function verifyCouponBilling (params) {
  return {
    type: SETTING_BILLING_VERIFY_BILLING_COUPON,
    payload: params
  }
}

export function setIsCouponValid (isCouponValid) {
  return {
    type: SETTING_BILLING_SET_STATUS_VALIDATION_COUPON,
    payload: {isCouponValid}
  }
}

export function setCouponDiscount (couponDiscount) {
  return {
    type: SETTING_BILLING_SET_COUPON_DISCOUNT,
    payload: {couponDiscount}
  }
}

export function setCouponDiscountRequest (couponDiscountRequest) {
  return {
    type: SETTING_BILLING_SET_COUPON_DISCOUNT_REQUEST,
    payload: {couponDiscountRequest}
  }
}

export function setCouponErrorMessage (errorMessage) {
  return {
    type: SETTING_BILLING_SET_COUPON_ERROR_MESSAGE,
    payload: {errorMessage}
  }
}

export function isValidatingCoupon (isValidating) {
  return {
    type: SETTING_BILLING_IS_VALIDATING_COUPON,
    payload: {isValidating}
  }
}



// WEBPACK FOOTER //
// ./app/actions/setting/billing/index.js